import { gql } from '@apollo/client';

export const MUTATION_SET_ASSETS_INTERNAL_STATE = gql`
  mutation AssetSetInternalInBulk($input: AssetSetInternalInBulkInput!) {
    assetSetInternalInBulk(input: $input) {
      assets {
        ... on AssetFeedItem {
          id
          internal
        }
      }
      errors {
        message
      }
    }
  }
`;
